var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 80,
    viewBox: "0 0 24 24",
    width: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_46",
    "data-name": "Layer 46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19 2h-14a3 3 0 0 0 -3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-14a3 3 0 0 0 -3-3zm-1.29 6.69-7.46 7.94a1 1 0 0 1 -.73.31 1 1 0 0 1 -.73-.31l-2.48-2.63a1 1 0 1 1 1.45-1.37l1.76 1.87 6.73-7.16a1 1 0 0 1 1.42 0 1 1 0 0 1 .04 1.35z",
    fill: "#b7b7b7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.7bb7e5093e7b7c8954098d62942a6444.svg";
export { ForwardRef as ReactComponent };